export default __webpack_public_path__ + "static/media/table-open.33210158.svg";